<template>
  <div class="Aviso">
    <div class="content">
      <headNav :activeNav="'Aviso'"></headNav>
      <h1>「 Política de privacidad 」</h1>
      <div class="privacidad">
        <p>
          Con el fin de mejorar la calidad del servicio y el reconocimiento de
          la marca,Magcaja se actualizará completamente a Muchamo.Por lo tanto,
          esta actualización de la marca solo afecta al nombre de la marca, el
          diseño visual, etc., y no afecta a la aplicación, el almacenamiento y
          el procesamiento de los datos de los usuarios y la información
          privada.
        </p>
        <p>
          Este documento es la Políticas de privacidad de Muchamo (en adelante,
          “Muchamo”), se encuentra en armonía con la normativa vigente sobre
          Protección de Datos Personales. En el presente documento, se señalan
          las finalidades de la información que usted nos otorga, quiénes son
          los encargados de tratarla, las medidas de protección y los medios
          para ejercer sus derechos como titular de los Datos Personales, entre
          otros aspectos. Por favor lea con detenimiento este documento para
          entender la información que recolectamos sobre usted, cómo la usamos y
          las circunstancias bajo las cuales la compartiremos con terceras
          partes.
        </p>
        <p>
          El propósito de esta política es informar a los usuarios de nuestro
          compromiso de proteger sus datos personales y las pautas que usamos y
          procesamos en función de estos datos para llevar a cabo nuestro
          negocio.
        </p>
        <p>
          Al utilizar esta aplicación o sitios web relacionados, acepta esta
          política de privacidad y otorga su consentimiento libre, claro,
          inequívoco e informado para la recopilación y el procesamiento de la
          información del usuario por parte de esta aplicación. Asimismo, usted
          (el usuario) declara su consentimiento a todos los aspectos divulgados
          en este documento y nos autoriza a tratar sus datos personales para
          los fines informados.
        </p>
        <p class="title">Consentimiento</p>
        <p>
          Al hacer uso de esta aplicación usted acepta esta Política de
          Privacidad y presta su consentimiento libre, expreso, inequívoco e
          informado para que esta aplicación recolecte y procese información del
          usuario. Asimismo, usted (el usuario) declara estar de acuerdo con
          todos los aspectos expuestos en este documento y nos autoriza a tratar
          sus datos personales para las finalidades expuestas.
        </p>
        <p>
          Cabe precisar que, si bien la interacción con el usuario está prevista
          para ser realizada a través de la aplicación, Muchamo podría habilitar
          una página web para interactuar con los usuarios y el solo uso de esta
          implicaría la aceptación de esta Política de Privacidad en los
          términos señalados precedentemente.
        </p>
        <p>
          Finalmente, Muchamo no requiere consentimiento para tratar sus datos
          personales obtenidos de fuentes accesibles al público; asimismo, podrá
          tratar sus datos personales de fuentes no públicas, siempre que dichas
          fuentes cuenten con su consentimiento para tratar y transferir dichos
          datos personales.
        </p>
        <p class="title">Permisos que le solicitamos y datos que recopilamos</p>
        <p>
          Cuando utiliza la aplicación Muchamo o utiliza nuestros servicios,
          recopilamos la siguiente información personal de usted con su permiso.
        </p>
        <p>
          Nosotros podríamos combinar la información brindada por usted con
          información recolectada de otras fuentes con la finalidad de
          actualizar datos que se encuentren incompletos o sustituirlos, en base
          a consultar de fuentes de acceso público.
        </p>
        <p>
          Esta información, y la información combinada, podría ser usada para
          cualquiera de los usos y fines señalados en el presente documento.
        </p>
        <p>
          La siguiente información se recoge de forma segura y mantenemos tus
          datos seguros.
        </p>
        <p>Información recaudada al utilizar la aplicación y/o web.</p>
        <p class="title">SMS</p>
        <p>
          Recopilaremos todos sus datos SMS, pero solo monitoreamos sus mensajes
          relacionados con transacciones financieras. Para ser específicos,
          monitorearemos el nombre del remitente, la descripción y el monto de
          la transacción para realizar la evaluación del riesgo crediticio. Lo
          anterior nos permite identificarte adecuadamente y verificar si
          calificas como persona a ser financiada por nosotros. Subiremos los
          datos de SMS al servidor de Muchamo (<span style="color: #0000ff"
            >https://api.muchamo.com</span
          >) a través de una conexión segura.
        </p>
        <!-- <p class="title">Contactos</p>
        <p>
          Recopilamos los contactos de su directorio telefónico, incluido el
          nombre, número de teléfono, tipo de cuenta, último contacto
          modificado, favoritos y otros datos opcionales (como la relación y la
          dirección estructural). Lo anterior le permitirá seleccionar, en su
          solicitud de préstamo, sus contactos de referencia, así como nos
          permitirá poder contactarlos para validar la identidad (del cliente y
          del referido), evitar fraudes, realizar seguimiento a la cobranza. De
          esta manera, podremos evaluar de una mejor manera su perfil crediticio
          y gestionar nuestros riesgos de identificación y gestión de cartera de
          créditos. Subiremos los datos de contactos al servidor de Muchamo
          (<span style="color: #0000ff">https://api.muchamo.com</span>) en un
          entorno de red seguro.
        </p> -->
        <p class="title">Ubicaciones</p>
        <p>
          Recopilamos y monitoreamos la información acerca de las ubicaciones de
          sus dispositivos para la evaluación del perfil del cliente y para
          evitar fraudes. Subiremos los datos de ubicaciones al servidor de
          Muchamo (<span style="color: #0000ff">https://api.muchamo.com</span>).
        </p>
        <p class="title">Celular:</p>
        <p>
          Recopilamos y monitoreamos información acerca de su dispositivo,
          incluyendo nombre, modelo, región, lengua, código de identificación,
          información de hardware y software, estatus, hábitos de uso,
          identificadores únicos como IMEI y números seriales. Dicha información
          nos es útil para identificar el dispositivo desde donde proviene la
          solicitud de préstamo y otras adicionales, para evaluar adecuadamente
          tu perfil y evitar fraudes.
        </p>
        <p>
          Además, recogeremos tu lista detallada de aplicaciones instaladas para
          evaluar tu propensión al préstamo y tu situación de deuda. Subiremos
          los datos de celular al servidor de Muchamo (<span
            style="color: #0000ff"
            >https://api.muchamo.com</span
          >).
        </p>
        <p class="title">Cámara:</p>
        <p>
          Se pedirá acceso a la cámara del dispositivo móvil para que puedas
          identificarte por medio de un “selfie” y además puedas proporcionarnos
          los documentos necesarios para el proceso de solicitud y evaluación de
          tu perfil de cliente. Subiremos los datos de cámara al servidor de
          Muchamo (<span style="color: #0000ff">https://api.muchamo.com</span>).
        </p>
        <p class="title">Calendario:</p>
        <p>
          Solicitaremos acceso a su calendario, para poder agendar la fecha de
          pago respectiva y los recordatorios respectivos. De esta manera,
          gestionamos nuestro riesgo de crédito y evitamos pagos vencidos.
          Subiremos los datos de calendario al servidor de Muchamo (<span
            style="color: #0000ff"
            >https://api.muchamo.com</span
          >).
        </p>
        <p class="title">Aplicaciones instaladas:</p>
        <p>
          Con el fin de evaluar la elegibilidad del cliente parasolicitar un
          prestamo, es necesario recopilarinformacion sobre la actividad en
          aplicaciones. Estainformacion incluye el nombre del paquete, el
          nombrede la aplicacion, la hora de la primera instalacion y lahora de
          actualizacion de la aplicacion. Toda estainformacion se cargar de
          forma encriptada ennuestro servidor seguro ubicado en
          (https://api.muchamo.com). Utilizamos estos datos para identificary
          analizar el comportamiento y el riesgo asociado conmultiples
          prestamos, con el objetivo de determinar sise puede procesar una
          solicitud de prestamo yprevenir el fraude.Le garantizamos que sus
          datos permanecerán confidenciales y no serán compartidos con terceros
          en ningún momento.
        </p>
        <p class="title">Datos de Contactos：</p>
        <p>
          Necesitamos que seleccione manualmente el contactos de emergencia
          desde su lista de contactos incluido nombre y número de teléfono, esta
          función sirve para cuando no podemos poner en contacto contigo. El
          nombre y el número de teléfono cargados y transmitidos se recogerán y
          utilizarán para gestionar los riesgos y realizar comprobaciones
          antifraude. Durante el uso de la App, envía datos de la lista de
          contactos a nuestro servidor de vez en cuando. Usted nos da
          explícitamente su consentimiento para ponernos en contacto con los
          números de su lista de contactos en caso de que su préstamo esté en
          mora y no podamos ponernos en contacto con usted. Muchamo nunca
          compartirá los datos con terceros sin su permiso. Sólo se recopilarán
          bajo su consentimiento. Si desea eliminar sus datos privados, puede
          enviar un correo electrónico a support@muchamo.com. Envíe una
          solicitud al servicio de atención al cliente y podemos eliminarla
          manualmente dentro de (3-5 días hábiles).
        </p>
        <p class="title">Almacenamiento (solo fotos en galería):</p>
        <p>
          Cuando usuarios seleccionan fotos del álbum de su teléfono móvil, la
          aplicación necesita acceso a la galería dentro de los archivos de
          multimedia del dispositivo. Este acceso facilita la selección y carga
          de imágenes requeridos en la solicitud de préstamo. Solamente las
          fotos seleccionadas manualmente por los usuarios se transmitirán a
          nuestra aplicación de manera encriptada, y se guardarán por 1 año a
          partir de la fecha de carga.
        </p>
        <p>
          Nunca recopilaremos su foto sin su consentimiento, si desea eliminar
          los datos de fotos, puede enviar una solicitud al servicio de atención
          al cliente a este correo electrónico: support@muchamo.com podemos
          eliminar los datos manualmente en 3-5 días hábiles.
        </p>
        <!-- <p class="title">Datos de Contactos：</p>
        <p>
          Necesitamos que seleccione manualmente el contactos de emergencia
          desde su lista de contactos incluido nombre y número de teléfono, esta
          función sirve para cuando no podemos poner en contacto contigo.
          Solamente los contactos seleccionados manualmente por los usuarios se
          transmitirán a nuestra aplicación de manera encriptada, y se guardarán
          por 1 año a partir de la fecha de carga. Nunca recopilaremos su
          información sin consentimiento. Si desea eliminar sus datos privados,
          puede enviar un correo electrónico a support@muchamo.com. Envíe una
          solicitud al servicio de atención al cliente y podemos eliminarla
          manualmente dentro de (3-5 días hábiles).
        </p>
        <p class="title">Actividad en apps:</p>
        <p>
          Necesitamos obtener la actividad en apps, incluido nombre del paquete,
          nombre de la aplicación, la hora de la primera instalación y la hora
          de actualización de la aplicación, para evaluar si el cliente es
          elegible para solicitar un préstamo. Cargaremos esta información a
          nuestro servidor (<span style="color: #0000ff"
            >https://api.muchamo.com</span
          >) encriptado, y se usa para identificar y analizar comportamiento y
          riesgo en múltiples préstamos para evaluar si un préstamo puede
          procesarse, lo que ayuda a prevenir el fraude.
        </p> -->
        <p class="title">Información personal del usuario</p>
        <p>
          Para realizar control de riesgo y evaluar la elegibilidad del usuario,
          necesitamos usar las informaciones personales incluido nombre
          completo, estado civil, género, fecha de nacimiento, edad, país,
          identificación oficial vigente, documento nacional de identidad (DNI),
          correo electrónico.
        </p>
        <p>
          Se va realizar el depósito bancario directamente al número de cuenta
          proporcionados por los usuarios.
        </p>
        <p class="title">El cooperador</p>
        <p>
          El SDK que utilizamos para conectar con el servicio de proveedor de
          Deeplink se entrega a través de múltiples canales (por ejemplo,
          Google, Facebook) con el fin de distinguir la fuente de atribución del
          canal del usuario y transmitir la identidad de cada canal, pero
          nuestro socio Deeplink no accede ni utiliza ninguna información de la
          cuenta social del usuario, tampoco nuestra propia app accede ni
          utiliza ninguna información de la cuenta social del usuario.
        </p>
        <p>
          En resumen, las finalidades para las que utilizaremos tus datos serán
          las siguientes:
        </p>

        <p></p>
        <p>
          Nosotros podríamos combinar la información brindada por usted con
          información recolectada de otras fuentes con la finalidad de
          actualizar datos que se encuentren incompletos o sustituirlos, en base
          a consultar de fuentes de acceso público.
        </p>
        <p></p>
        <p>
          Esta información, y la información combinada, podría ser usada para
          cualquiera de los usos y fines señalados en el presente documento.
          Para brindarte nuestros servicios y mejorar tu experiencia en nuestra
          página web y aplicación.
        </p>
        <p></p>
        <p>
          Para fines de funcionalidad y operatividad de la web y la aplicación.
        </p>
        <p></p>
        <p>
          Para poder brindarte soporte, resolver cualquier duda o consulta y
          resolver tus reclamos.
        </p>

        <p>Para proteger tu seguridad y la de nuestra web y aplicación.</p>

        <p></p>
        <p>
          Para satisfacer un interés legítimo (que no anula nuestro deber de
          proteger tus datos personales) como la investigación y el desarrollo
          de nuestros servicios, promover el sitio web y proteger nuestros
          derechos e intereses legales.
        </p>

        <p>
          Para procesar tus datos con el objeto de cumplir con una obligación
          legal.
        </p>

        <p></p>
        <p>
          Para procesar tus datos con el objeto de cumplir con una obligación
          contractual.
        </p>

        <p class="title">Información proporcionada por usted</p>
        <p>
          Muchamo recabará de usted (en adelante el “Titular”) los siguientes
          datos personales (en lo sucesivo los “datos” o los “datos personales”)
          en tu calidad de uno de nuestros clientes:
        </p>

        <p></p>
        <p>
          datos de contacto (correo electrónico e número de teléfono:solo para
          verificación de inicio de sesión);datos de identificación (nombre,
          fecha de nacimiento, captura de imagen, identificación oficial, género
          asignado);
        </p>
        <p></p>
        <p>datos biométricos;</p>
        <p></p>
        <p>datos de localización y geolocalización (ubicación aproximada);</p>
        <p></p>
        <p>datos laborales y educativos;A otras sociedades controladoras</p>
        <p></p>
        <p>
          datos de comunicación con Muchamo (solicitudes de atención al cliente,
          respuestas a aclaraciones u otras comunicaciones a través de mensajes
          SMS, correo electrónico o grabación de llamadas);
        </p>
        <p></p>
        <p>
          datos de tu teléfono celular o dispositivo móvil (información del
          hardware, IMEI, dirección IP, dirección MAC, GPS ADID o identificación
          de otro dispositivo, operador móvil);
        </p>
        <p></p>
        <p>
          datos patrimoniales y financieros (ingresos o datos o documentos de tu
          empleo, grado de escolaridad, propósito o uso que se le dará al
          préstamo);
        </p>
        <p></p>
        <p>datos que proporciones en tu solicitud de préstamo;</p>
        <p></p>
        <p>
          datos transaccionales de las operaciones que realizas con nosotros o a
          través de nosotros, así como de las operaciones que realizas con
          transmisores de dinero, instituciones de fondos de pago electrónico,
          instituciones de financiamiento colectivo, instituciones de crédito y
          otras instituciones financieras o comercios electrónicos;
        </p>
        <p></p>
        <p>
          datos de uso de la aplicación de Muchamo y de otras aplicaciones
          (detalles de instalación, tráfico, navegación).
        </p>

        <p class="title">
          Necesidad de la recolección y procesamiento de tus datos
        </p>
        <p>
          Muchamo te informa que los datos personales y personales sensibles
          (recolectados incidentalmente) que te solicita, de conformidad con el
          presente Aviso de Privacidad, son necesarios y suficientes para que
          Muchamo realice un proceso de evaluación de riesgo de crédito y
          probabilidad de pago (scoring crediticio) en base a tu perfil y así
          poder determinar tu capacidad crediticia, lo cual es la base
          fundamental de la determinación de Muchamo para aprobar o rechazar el
          otorgamiento de tu solicitud de crédito y dar inicio a la relación
          jurídica contigo, así como para las demás finalidades primarias y
          secundarias que se señalan en el presente Aviso de Privacidad. Cabe
          resaltar que, la decisión final al respecto no es tomada de forma
          manual por un oficial o empleado de Muchamo, sino que, dicha decisión
          es tomada por los sistemas automatizados de Muchamo de conformidad con
          lo señalado en la sección “Decisiones Automatizadas” del presente
          Aviso de Privacidad.
        </p>
        <p>¿CÓMO OBTENEMOS Y ACTUALIZAMOS TUS DATOS?</p>
        <p>Los datos personales serán obtenidos y actualizados cuando:</p>

        <p></p>
        <p>Bajas la aplicación de Muchamo y/o nos solicitas un préstamo;</p>
        <p></p>
        <p>
          Interactúas con nosotros, incluyendo tus datos personales que
          voluntariamente compartes con nuestro departamento de atención al
          cliente o con nuestros empleados y agentes;
        </p>
        <p></p>
        <p>
          Desde tú teléfono celular o dispositivo móvil otorgas acceso y
          permisos que se describe abajo;
        </p>
        <p></p>
        <p>
          Se hace consultas a través de los buros de crédito o agencias para
          prevenir el fraude;
        </p>
        <p></p>
        <p>
          Se consulta Cookies, web beacons y otros medios remotos de recolección
          automática de datos;
        </p>
        <p></p>
        <p>
          Se consulta a los Transmisores de dinero instituciones de fondos de
          pago electrónico, instituciones de financiamiento colectivo,
          instituciones de crédito y otras instituciones financieras y comercios
          electrónicos, con tu consentimiento, cuando sea necesario; y/o
        </p>
        <p></p>
        <p>
          Se consulta a terceros y otras fuentes públicas, con tu
          consentimiento, siempre que sea necesario.
        </p>

        <p class="title">Objetivo de la recogida de datos</p>
        <p>
          Las finalidades primarias (en lo sucesivo, las “Finalidades
          Primarias”) que dan origen y son necesarias para el mantenimiento y
          cumplimiento de la relación jurídica entre Muchamo y tú son las
          siguientes:
        </p>

        <p></p>
        <p>
          Verificar tu identidad, prevenir fraudes y cumplir con nuestras
          obligaciones de “conoce a tu cliente” bajo las leyes aplicables de
          prevención de lavado de dinero;
        </p>
        <p></p>
        <p>
          Crear tu perfil crediticio y asignarte una calificación crediticia
          para determinar si eres elegible para usar los productos y servicios
          de Muchamo;
        </p>
        <p></p>
        <p>
          Llevar a cabo la identificación y el conocimiento mediante recolección
          de datos personales, así como la integración de tu expediente que se
          mantendrá en la infraestructura tecnológica y sistemas de información
          de Muchamo y en otros archivos;
        </p>
        <p></p>
        <p>
          Incorporar los datos personales en instrumentos jurídicos, dar
          cumplimiento a los contratos que celebres con Muchamo, incluyendo,
          pero no limitado a ciertos contratos de usuario de nuestra aplicación
          y plataformas y los contratos de préstamo o crédito entre el Titular y
          Muchamo y administrar y manejar dichos contratos;
        </p>
        <p></p>
        <p>
          Originar, gestionar, dar servicio, mantener y exigir las deudas del
          Titular;
        </p>
        <p></p>
        <p>
          Brindarte servicios y gestionar tu cuenta con Muchamo y darte soporte
          como cliente;
        </p>
        <p></p>
        <p>
          Enviarte información de transacciones o notificaciones de
          transacciones, recordatorios de pago y anuncios a través de servicios
          de telefonía automáticos o mensajes pre-grabados, mensajes de texto o
          email;
        </p>
        <p></p>
        <p>
          Ceder o transmitir a un tercero, mediante cualquier medio, los
          derechos y/u obligaciones derivadas de los contratos antes señalados;
        </p>
        <p></p>
        <p>
          Utilizar los datos personales, en cualquier tipo de acto o diligencia
          de cobranza judicial o extrajudicial;
        </p>
        <p></p>
        <p>
          Cumplir con todas las leyes, reglamentos y disposiciones de carácter
          general aplicables;
        </p>
        <p></p>
        <p>Investigar cambios en tu perfil transaccional;</p>
        <p></p>
        <p>Prevención de fraudes;</p>
        <p></p>
        <p>
          Obtener datos personales para mejorar los modelos crediticios de
          Muchamo, sus modelos de datos y otros servicios; y
        </p>
        <p></p>
        <p>
          Analizar el comportamiento del cliente y mantener la calidad de
          nuestros servicios.
        </p>

        <p>
          Las finalidades secundarias (en lo sucesivo, las “Finalidades
          Secundarias”) que no son necesarias para el mantenimiento y
          cumplimiento de la relación jurídica entre Muchamo y tú, son las
          siguientes:
        </p>

        <p></p>
        <p>
          Envío de noticias, invitaciones a eventos de Muchamo y/o sus empresas
          subsidiarias y afiliadas;
        </p>
        <p></p>
        <p>Realización de encuestas para mejorar nuestro servicio;</p>
        <p></p>
        <p>
          Uso de imágenes y testimonios que nos proporciones voluntariamente
          para fines publicitarios; y
        </p>
        <p></p>
        <p>
          La mercadotecnia, publicidad y/o promoción de los productos y/o
          servicios que sean ofrecidos por Muchamo al Titular, por cualquier
          medio material y/o electrónico. Con tu consentimiento al presente
          Aviso de Privacidad otorgas tu consentimiento expreso para que podamos
          contactarte con la finalidad de ofrecerte servicios financieros.
        </p>
        <p>
          Tu consentimiento es necesario para las finalidades secundarias. Si no
          estás de acuerdo con el uso de tus datos de contacto para dichas
          finalidades secundarias, envíanos un correo a support@muchamo.com.
          Esperaremos cinco días hábiles antes de usar tus datos personales para
          finalidades secundarias.
        </p>
        <p class="title">¿Con quién compartimos sus datos?</p>
        <p>
          Los datos personales se transferirán a nivel nacional e internacional,
          a las personas o entidades ubicadas en los siguientes tipos,
          categorías o sectores, con las siguientes finalidades:
        </p>
        <p>
          A. A otras sociedades controladoras, subsidiarias o afiliadas, o a una
          sociedad matriz o a cualquier sociedad del mismo grupo de Muchamo, que
          operen bajo los mismos procesos y políticas internas, con la finalidad
          de hacer uso de servicios compartidos dentro del grupo de Muchamo y
        </p>
        <p>además para:</p>

        <p>
          Llevar a cabo la identificación y el conocimiento mediante recolección
          de datos personales del Titular, así como la integración de los datos
          personales en la infraestructura tecnológica de Muchamo, así como en
          sus sistemas de información y otros archivos;
        </p>
        <p>
          Incorporar los datos personales del Titular en instrumentos jurídicos,
          dar cumplimiento a las obligaciones del Titular bajo los contratos
          celebrados entre el Titular y Muchamo, incluyendo de manera
          enunciativa, más no limitativa, ciertos contratos de usuario de
          nuestra aplicación y plataformas y los contratos de préstamo o crédito
          entre el Titular y Muchamo y administrar y manejar dichos contratos;
        </p>
        <p>
          Ceder o transmitir a un tercero, mediante cualquier medio, los
          derechos y/u obligaciones derivadas de los contratos antes señalados;
        </p>
        <p>
          Utilizar los datos personales, en cualquier tipo de acto o diligencia
          de cobranza judicial o extrajudicial;
        </p>
        <p>
          Cumplir con todas las leyes, reglamentos y disposiciones de carácter
          general aplicables;
        </p>
        <p>
          Prospectar y evaluar los datos personales para crear y asignar al
          titular una calificación crediticia o grado de calificación similar.
        </p>
        <p>
          Obtener información para mejorar nuestro modelo crediticio, de datos y
          de servicios;
        </p>
        <p>Investigar cambios en tu perfil transaccional;</p>
        <p>Prevención de fraudes;</p>
        <p>
          Originar, gestionar, dar servicio, mantener y exigir la deuda del
          Titular.
        </p>

        <p>
          B. A autoridades nacionales y extranjeras competentes, con la
          finalidad de dar cumplimiento a alguna ley, reglamento o disposición
          legal aplicable, así como con la finalidad de prevenir un daño.
        </p>
        <p>
          C. A terceros que adquieran la cartera crediticia de Muchamo o que
          otorguen financiamiento a Muchamo con la finalidad de que Muchamo
          pueda obtener financiamiento o recursos.
        </p>
        <p>
          D. A terceros interesados en otorgar financiamientos o adquirir las
          acciones o activos de Muchamo o de sus accionistas o filiales en Perú
          o alrededor del mundo o en fusionarse con Muchamo.
        </p>
        <p>
          E. Con nuestros socios comerciales, para fines de prospección
          comercial y servicios relacionados ofrecidos por Muchamo y para darte
          acceso a los servicios de terceros dentro de la aplicación de Muchamo.
        </p>
        <p>
          Asimismo, y de acuerdo con las leyes vigentes, Muchamo deberá, con el
          objeto de cumplir con las Finalidades Primarias descritas en el
          presente, transferir de tiempo en tiempo, información de crédito del
          Titular a las Sociedades de Información Crediticia o Burós de Crédito,
          y en este sentido, al aceptar el presente Aviso de Privacidad (en lo
          sucesivo, este “Aviso”) y al consentir a la celebración del Contrato
          de Usuario, usted confirma que podemos transmitir su información a
          dichas Sociedades de Información Crediticia o Burós de Crédito,
          incluyendo información sobre el incumplimiento a los contratos
          celebrados entre el Titular y Muchamo, entre otros el Contrato del
          Usuario.
        </p>
        <p>
          También compartimos tus datos personales con terceros prestadores de
          servicios relacionados con los desembolsos, la transferencia de
          fondos, servicios de pagos, proveedores de seguridad de información,
          aseguradoras, despachos de cobranza, asesores contables y legales,
          proveedores de software para análisis de datos, transferencias y
          servicios de almacenamiento y otros prestadores de servicios que
          procesan tus datos personales por cuenta de Muchamo.
        </p>
        <p class="title">
          Puedes negarte o revocar el consentimiento para tratar tus datos
        </p>
        <p>
          En caso de que desees revocar tu consentimiento o negarte al
          tratamiento de tus datos personales para las Finalidades Secundarias,
          con posterioridad a la firma y aceptación del presente Aviso, deberás
          enviar un correo electrónico a la dirección indicada en la sección
          anterior al Departamento de Protección de Datos Personales/Equipo de
          Atención al Cliente, support@muchamo.com, siguiendo el procedimiento
          para la Negativa al Tratamiento y Revocación del Consentimiento que se
          describe en este Aviso.
        </p>
        <p>
          De acuerdo con lo anterior, el Departamento de Protección de Datos
          Personales/Equipo de Atención al Cliente es el encargado de atender
          todas las solicitudes de ejercicio de los derechos ARCO (acceso,
          rectificación, cancelación u oposición) mismo que puedes contactar en
          caso de cualquier duda o solicitud con respecto a tus datos personales
          a través del correo electrónico y teléfono antes indicados.
        </p>
        <p>
          ¿QUÉ MEDIOS TIENES PARA LIMITAR EL USO Y DIVULGACIÓN DE DATOS
          PERSONALES?
        </p>
        <p>
          Muchamo ha creado un listado de exclusión para personas que no deseen
          recibir publicidad de Muchamo. Si recibes publicidad de Muchamo y no
          deseas seguir recibiéndola, podrás enviar un correo electrónico con tu
          nombre completo a support@muchamo.com, solicitando tu eliminación de
          la lista de distribución con base en la cual se lleva a cabo el envío
          de la información o publicidad. En el mismo correo electrónico podrás
          solicitar más datos acerca de este listado.
        </p>
        <p class="title">Tus derechos ARCO</p>
        <p>
          Sobre los datos que gestionamos y almacenamos en ficheros. Tiene los
          siguientes derechos:
        </p>
        <p>El derecho a solicitar el acceso a sus datos personales</p>
        <p>El derecho a solicitar la corrección de sus datos personales</p>
        <p>
          El derecho a que se eliminen sus datos personales (derecho al olvido).
        </p>
        <p>
          El derecho a oponerse al procesamiento de sus datos personales y, en
          ciertas circunstancias, a restringir el procesamiento de sus datos
          personales.
        </p>
        <p>
          El derecho incondicional a oponerse al procesamiento de sus datos
          personales con fines de marketing directo.
        </p>
        <p>
          Si el procesamiento de su información personal se basa en su
          consentimiento, tiene derecho a retirar su consentimiento en cualquier
          momento. Su retirada no afectará a la licitud del tratamiento
          realizado antes de su retirada del consentimiento. Puede retirar su
          consentimiento en su perfil, en nuestro sitio web o contactándonos por
          correo electrónico a support@muchamo.com.
        </p>
        <p class="title">Modificaciones al política de privacidad</p>
        <p>
          Muchamo se reserva el derecho de efectuar en cualquier momento cambios
          o modificaciones al presente Política de Privacidad, ante la necesidad
          de proporcionarle la protección continua y adecuada a sus datos
          personales, así como para la atención de novedades legislativas o
          jurisprudenciales, políticas internas, y prácticas del mercado. Los
          cambios y modificaciones estarán disponibles a través de los
          siguientes medios: anuncios en nuestras oficinas y en el portal web de
          Muchamo, a través de nuestro personal que recabe sus Datos Personales.
          Es aconsejable revisar el Política de Privacidad tras la enlace
          <a href="https://www.muchamo.com/Aviso" target="_blank"
            >https://www.muchamo.com/Aviso</a
          >
          para ser enterado de cada modificación que habrá en el futuro. Si
          tienen cualquier duda sobre el Política de Privacidad, por favor no
          duden en ponerse en contacto con atención al cliente tras llamada 
           o correo electrónico (support@muchamo.com).
        </p>
        <p class="title">Cesión de posición contractual y cesión de derechos</p>
        <p>
          El usuario autoriza expresamente la cesión de derechos y/o la cesión
          de posición contractual de esta política de privacidad y de los datos
          personales en favor de cualquier persona que (i) quede obligada por la
          presente política y/o (ii) que sea el nuevo responsable de los bancos
          de datos que contengan los datos personales.
        </p>
        <p>
          Luego de producida la cesión, Muchamo no tendrá ninguna
          responsabilidad con respecto de cualquier hecho que ocurra a partir de
          la fecha de la cesión.
        </p>
        <p>
          El nuevo responsable del banco de datos asumirá todas y cada una de
          las obligaciones de Muchamo establecidas en la presente política
          respecto al tratamiento, resguardo y conservación de los datos
          personales.
        </p>
        <p class="title">
          Sobre el carácter obligatorio de los datos personales, y las
          consecuencias de no proporcionar la información personal requerida
        </p>
        <p>
          La recopilación de los datos personales es necesaria y obligatoria
          para poder cumplir con las finalidades descritas en la presente
          política.
        </p>
        <p>
          En caso no nos permitas acceder a la información personal requerida,
          te comunicamos que, no podremos brindarte los servicios que prestamos
          a través de nuestra página web y aplicación móvil, y en consecuencia,
          no podrás realizar las operaciones financieras que en ellas se
          ofrecen.
        </p>
        <p class="title">Seguridad de los datos personales</p>
        <p>
          En cumplimiento de la normativa vigente, hemos adoptado las medidas
          técnicas y organizativas de seguridad necesarias para garantizar la
          protección de los datos personales conservados, transmitidos y
          procesados de nuestros usuarios con el fin de evitar su alteración,
          pérdida o el tratamiento o acceso no autorizados que puedan afectar a
          la integridad, confidencialidad y disponibilidad de la información,
          teniendo en cuenta el estado de la tecnología, la naturaleza de los
          datos almacenados y los riesgos a los que están expuestos.
        </p>
        <p>
          Asimismo, los datos personales son recolectados a través del canal
          cifrado y como parte del proceso de registro. De igual forma, la
          contraseña utilizada en el momento de registro se encuentra cifrada.
        </p>
        <p>
          Por su parte, la información entre el navegador y la página web -o
          aplicación móvil-, se transfiere de forma encriptada a través de
          Secure Socket Layer (SSL). Sobre este último punto, al transmitir
          información.
        </p>
        <p>
          No obstante, a pesar de que en Muchamo realizamos nuestros mejores
          esfuerzos para proteger tus datos personales mediante el empleo de
          diversas técnicas de seguridad, la transmisión de información mediante
          las redes de comunicación y de Internet no es totalmente segura debido
          a actos ilícitos como ciberataques o acciones imputables al propio
          usuario al no tener precaución con sus propios datos.
        </p>
        <p>
          En tal sentido, toda la información que nos proporciones se enviará
          por tu cuenta y riesgo. Muchamo no se hace responsable por
          interceptaciones ilegales o violación de sus sistemas o bases de datos
          por parte de personas no autorizadas, así como la indebida utilización
          de la información obtenida por esos medios, o de cualquier intromisión
          ilegítima que escape al control de ésta y que no le sea imputable.
        </p>
        <p>
          A pesar de lo anterior, en caso de que Muchamo detecte una violación a
          la seguridad de los datos personales proporcionados, y ello signifique
          un alto riesgo para tus derechos y libertades, te comunicaremos
          inmediatamente tal situación en un lenguaje claro y sencillo, de modo
          que puedas comprender fácilmente la naturaleza de la infracción
          cometida contra tus datos personales.
        </p>
        <p>
          Dicha comunicación no será necesaria cuando Muchamo haya adoptado
          medidas de protección técnicas y organizativas apropiadas aplicadas a
          los datos personales afectados, de modo que éstos resulten
          indescifrable para quien intentó acceder a ellos (ej. el cifrado).
          Tampoco será necesario cuando suponga un esfuerzo desproporcionado
          para Muchamo, ya que tratándose de varios usuarios afectados resulta
          más fácil para nosotros optar por una comunicación pública u otras
          opciones.
        </p>
        <p class="title">Ley y jurisdicción</p>
        <p>
          Esta política de privacidad y cualquier disputa o reclamo que surjan
          como consecuencia de la misma se encuentra normada en la ley peruana.
        </p>
        <p class="title">Resolución de conflictos</p>
        <p>
          Las partes se someten a la competencia de los jueces y tribunales de
          Lima, Cercado para resolver cualquier duda, diferencia o controversia
          que pudiera surgir entre las partes respecto a los alcances de las
          políticas de privacidad de Muchamo, renunciando al fuero que pudiera
          corresponderles en razón a su domicilio.
        </p>
        <p>Dudas y requerimientos</p>
        <p>
          Preguntas, solicitudes y comentarios asociados a esta política de
          privacidad son bienvenidos y deberán ser dirigidos a
          support@muchamo.com
        </p>
        <p class="title">Contacto</p>
        <p>
          Si tiene alguna pregunta o sugerencia sobre esta política de
          privacidad, no dude en ponerse en contacto con nosotros.
        </p>
        <!-- <p>Nombre de empresa: Perucred Digital Finance SAC</p> -->
        <p>Correo electrónico: support@muchamo.com</p>
        <!-- <p>Número telefónico: +51 {{ phone }}</p> -->
        <p>Dirección: Miraflores, Lima, Perú</p>
        <!-- <p>Horario de trabajo: {{ daySection }}</p> -->
      </div>
    </div>
    <foot-page></foot-page>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import footPage from "../components/footPage.vue";

export default {
  name: "Aviso",
  components: { headNav, footPage },
  data() {
    return {
      phone: "",
      daySection: "",
    };
  },
  created() {
    this.getInformation();
  },
  methods: {
    getInformation() {
      if (localStorage.getItem("customerData") !== "undefined") {
        const data = JSON.parse(localStorage.getItem("customerData"));
        this.phone = data.customerServicePhone.phone;
        this.daySection = data.customerServiceWorkTimeInfo.daySection;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
*::-webkit-scrollbar {
  display: none;
}
.Aviso {
  width: 100%;
  background: #03040c;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 50px;
    box-sizing: border-box;
    h1 {
      font-size: 52px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #e8e8e9;
      margin: 66px 0 40px 0;
    }
    .privacidad {
      p {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #e8e8e9;
        margin-bottom: 20px;
      }
      .title {
        font-weight: 600;
        font-size: 28px;
      }
    }
  }
}
</style>
